import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { VmeCommonModule } from '../../vme-common.module';
import { VMEComponentsModule } from '../../vme-components.module';
import { VmeDirectivesModule } from '../../vme-directives.module';
import { VmePipesModule } from '../../vme-pipes.module';
import { CostRejectionReasonsComponent } from './cost-rejection-reasons.component';

const routes: Routes = [
  { path: '', component: CostRejectionReasonsComponent, data: { title: 'Cost Rejection Reasons' } },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class CostRejectionReasonsRoutingModule {}

@NgModule({
  imports: [
    CostRejectionReasonsRoutingModule,
    VmeCommonModule,
    VmeDirectivesModule,
    VmePipesModule,
    VMEComponentsModule,
  ],
  declarations: [CostRejectionReasonsComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  exports: [CostRejectionReasonsComponent],
})
export class CostRejectionReasonsModule {}
